import { render, staticRenderFns } from "./flowActivityForm.vue?vue&type=template&id=2f622d60&"
import script from "./flowActivityForm.vue?vue&type=script&lang=js&"
export * from "./flowActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports